<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-20 md-small-size-100">
      <md-field class="md-layout-item" v-if="statusFilterList">
        <label for="pages">Estado</label>
        <md-select v-model="statusId" name="pages">
          <md-option :value="0">Cualquier estado</md-option>
          <md-option
            v-for="item in statusFilterList"
            :key="item.id"
            :value="item.id"
            >{{ item.name }}
          </md-option>
        </md-select>
      </md-field>
    </div>

    <div class="md-layout-item md-size-20 md-small-size-100">
      <md-field>
        <md-input
          v-on:keyup.enter="onChangeFilter()"
          type="search"
          class="mb-3"
          clearable
          style="width: 200px"
          placeholder="Nombre del cliente"
          v-model="name"
        >
        </md-input>
      </md-field>
    </div>
    <div class="md-layout-item md-size-20 md-small-size-100">
      <md-field>
        <md-input
          v-on:keyup.enter="onChangeFilter()"
          type="text"
          class="mb-3"
          clearable
          style="width: 200px"
          placeholder="Cédula del cliente"
          v-model="documentValue"
        >
        </md-input>
      </md-field>
    </div>
    <div class="md-layout-item text-center">
      <md-button
        class="md-just-icon md-info md-simple"
        @click.native="onChangeFilter()"
      >
        <md-icon>youtube_searched_for</md-icon>
      </md-button>
    </div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>assignment</md-icon>
        </div>
        <h4 class="title">Clientes CAPITAL77</h4>
      </md-card-header>
      <md-card-content v-if="tableData">
        <md-table
          :value="queriedData"
          :md-sort.sync="currentSort"
          :md-sort-order.sync="currentSortOrder"
          :md-sort-fn="customSort"
          class="paginated-table table-striped table-hover"
        >
          <md-table-toolbar>
            <md-field>
              <label for="pages">Por página</label>
              <md-select v-model="pagination.perPage" name="pages">
                <md-option
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                  {{ item }}
                </md-option>
              </md-select>
            </md-field>

            <md-field>
              <md-input
                type="search"
                class="mb-3"
                clearable
                style="width: 200px"
                placeholder="Buscar localmente"
                v-model="searchQuery"
              >
              </md-input>
            </md-field>
          </md-table-toolbar>

          <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label="Cédula">{{
              item.documentValue
            }}</md-table-cell>

            <md-table-cell
              md-label="Nacimiento"
              class="td-name"
              md-sort-by="paymentDate"
            >
              {{ item.birthDate }}
              <!-- <br />
              <small>{{ item.dayLimit }} días</small> -->
            </md-table-cell>
            <md-table-cell md-label="Estado">{{
              item.currentStatus
            }}</md-table-cell>

            <md-table-cell
              md-label="Nombre Completo"
              class="td-name"
              md-sort-by="fullName"
            >
              {{ item.fullName }}
            </md-table-cell>
            <md-table-cell md-label="Categoría">{{
              item.category
            }}</md-table-cell>

            <md-table-cell md-label="Celular">{{
              item.cellphone
            }}</md-table-cell>
            <md-table-cell md-label="Correo">{{ item.email }}</md-table-cell>
            <md-table-cell md-label="">
              <md-button
                class="md-just-icon md-info md-simple"
                @click.native="handleEdit(item)"
              >
                <md-icon>tag_faces</md-icon>
              </md-button>
            </md-table-cell>
          </md-table-row>
        </md-table>
        <div class="footer-table md-table">
          <table>
            <tfoot>
              <tr>
                <th
                  v-for="item in footerTable"
                  :key="item.name"
                  class="md-table-head"
                >
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">
                      {{ item }}
                    </div>
                  </div>
                </th>
              </tr>
            </tfoot>
          </table>
        </div>
      </md-card-content>
      <md-card-actions md-alignment="space-between">
        <div class="">
          <p class="card-category">
            Viendo entre {{ from + 1 }} y {{ to }} de {{ total }} registros
          </p>
        </div>
        <pagination
          class="pagination-no-border pagination-primary"
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :total="total"
        >
        </pagination>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import { Pagination, Modal } from "@/components";
import Fuse from "fuse.js";
import Swal from "sweetalert2";
import gql from "graphql-tag";
import Constants from "../../constants";

export default {
  components: {
    Pagination
  },
  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },
  data() {
    return {
      currentCredit: {},
      name: null,
      statusId: null,
      documentValue: null,
      dateStart: null,
      dateEnd: null,
      currentSort: "additionalPayments",
      currentSortOrder: "asc",
      pagination: {
        perPage: 20,
        currentPage: 1,
        perPageOptions: [10, 20, 50],
        total: 0
      },
      statusFilter: null,
      statusFilterList: [],
      footerTable: [
        "Cédula",
        "Nacimiento",
        "Estado",
        "Nombre Completo",

        "Categoría",
        "Celular",
        "Correo",

        ""
      ],
      searchQuery: "",
      smallAlertModal: false,
      tableData: [],
      searchedData: [],
      fuseSearch: null
    };
  },
  methods: {
    executeQueryCredits() {
      this.$apollo
        .query({
          query: gql`
            query findCustomAccountsByFiltersAdmin(
              $documentValue: String
              $statusId: Int
              $fullName: String
            ) {
              findCustomAccountsByFiltersAdmin(
                documentValue: $documentValue
                statusId: $statusId
                fullName: $fullName
              ) {
                clientId
                documentValue
                birthDate
                currentStatus
                fullName
                category
                cellphone
                email
              }
            }
          `,
          variables: {
            documentValue: this.documentValue,
            statusId: this.statusId,
            fullName: this.name
          }
        })
        .then(data => {
          this.tableData = data.data.findCustomAccountsByFiltersAdmin;

          // Fuse search initialization.
          this.fuseSearch = new Fuse(this.tableData, {
            keys: ["fullName", "documentValue"],
            threshold: 0.3
          });
        })
        .catch(error => {
          Constants.catchError(
            error,
            this.$apollo.provider.defaultClient,
            this,
            false
          );
        });
    },
    onChangeFilter() {
      this.executeQueryCredits();
      this.searchQuery();
    },
    currencyValue(value) {
      return Constants.currencyValue(value);
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
    smallAlertModalHide: function() {
      this.smallAlertModal = false;
    },
    handleLike(item) {
      Swal.fire({
        title: `You liked ${item.name}`,
        buttonsStyling: false,
        type: "success",
        confirmButtonClass: "md-button md-success"
      });
    },
    handleEdit(item) {
      this.$router.push("/client/" + item.clientId);
      this.$router.go();
    },
    handleDelete(item) {
      Swal.fire({
        title: "Are you sure?",
        text: `You won't be able to revert this!`,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "Yes, delete it!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.deleteRow(item);
          Swal.fire({
            title: "Deleted!",
            text: `You deleted ${item.name}`,
            type: "success",
            confirmButtonClass: "md-button md-success btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    deleteRow(item) {
      let indexToDelete = this.tableData.findIndex(
        tableRow => tableRow.id === item.id
      );
      if (indexToDelete >= 0) {
        this.tableData.splice(indexToDelete, 1);
      }
    }
  },
  mounted() {
    this.executeQueryCredits();
    this.$apollo
      .query({
        query: gql`
          query getStatus($type: String!) {
            getStatus(type: $type) {
              id: stateId
              name: stateName
              description: stateDescription
            }
          }
        `,
        variables: {
          type: "1"
        }
      })
      .then(data => {
        this.statusFilterList = data.data.getStatus;
      });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      result = this.fuseSearch.search(this.searchQuery);
      this.searchedData = result;
    },
    statusId() {
      this.onChangeFilter();
    },
    dateStart() {
      this.onChangeFilter();
    },
    dateEnd() {
      this.onChangeFilter();
    }
  }
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}
</style>
